import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Modal from "src/react/components/modal";
import formatCurrency from "src/lib/format-currency";
import { EXPRESS_DELIVERY_COST_IN_PENCE } from "src/data/app-constants";

function ExpressDeliveryInfoModal({ isNextDay, close }) {
  const expressDelivery = formatCurrency({
    value: EXPRESS_DELIVERY_COST_IN_PENCE,
  });
  return (
    <Modal closeModal={close} data-selector="ExpressDeliveryInfoModal">
      {isNextDay ? (
        <Fragment>
          <p>
            <strong>Free Delivery: </strong>
            <br />
            Usually arrives within 5 working days.{" "}
          </p>
          <p>
            <strong>Next Day Delivery: </strong>
            <br />
            Orders placed by 3pm will be delivered next day{" "}
          </p>
        </Fragment>
      ) : (
        <Fragment>
          <p>
            <strong>Free Delivery: </strong>
            <br />
            Usually arrives within 5 working days.{" "}
          </p>
          <p>
            <strong>Express Delivery ({expressDelivery}): </strong>
            <br />
            Orders shipped same day when ordered before 2pm, and are delivered
            in 1-2 working days.{" "}
          </p>
        </Fragment>
      )}
    </Modal>
  );
}

ExpressDeliveryInfoModal.propTypes = {
  close: PropTypes.func.isRequired,
  isNextDay: PropTypes.bool,
};

export default ExpressDeliveryInfoModal;
